import axios from 'axios';
const auth = axios.create({ baseURL: process.env.REACT_APP_API_826 || '' });
//const auth = axios.create({ baseURL : 'http://localhost:9008'});
export default auth;